export enum UserOnboardingSteps {
  Terms = 1,
  You = 2, // PersonalDetails
  YourPlan = 3, // step is only for individual
  YourHsa = 4,
  YourFamily = 5, // step is only when plantype family
  Finish = 6,

  // only for claim account users
  ClaimAccountTerms = 7,
  ClaimAccountPersona = 8,
  ClaimAccountFinished = 9,

  VerifyIdentity = 10,
  Investments = 11,
}

export const onboardingStepsKeyRing = {
  "claim-terms-and-conditions": UserOnboardingSteps.ClaimAccountTerms,
  "claim-your-hsa": UserOnboardingSteps.ClaimAccountPersona,
  "finish-claim": UserOnboardingSteps.ClaimAccountFinished,

  "terms-and-conditions": UserOnboardingSteps.Terms,
  "personal-details": UserOnboardingSteps.You,
  "your-plan": UserOnboardingSteps.YourPlan,
  "your-hsa": UserOnboardingSteps.YourHsa,
  "your-family": UserOnboardingSteps.YourFamily,
  "verification": UserOnboardingSteps.VerifyIdentity,
  "investments": UserOnboardingSteps.Investments,
  "finish": UserOnboardingSteps.Finish,
};


type UserOnboardingStepKey = keyof typeof onboardingStepsKeyRing;
const keysArray = Object.keys(onboardingStepsKeyRing) as UserOnboardingStepKey[];

export function stepFromKey (key: UserOnboardingStepKey): UserOnboardingSteps {
  return onboardingStepsKeyRing[key];
}


export function keyFromStep (step: UserOnboardingSteps): UserOnboardingStepKey {
  return keysArray.find(k => onboardingStepsKeyRing[k] === step);
}